import {createContext} from 'react';

export const GeneralContext = createContext({});

export const SearchProductContext = createContext({});

export const SelectedProductContext = createContext({});

export const AssignedProductContext = createContext({});